import { object, string } from "yup";

export const erpSettingsSchema = object({
    erpType: string()
        .required("Erp Uygulaması seçimi zorunludur."),
    customerSyncFilter: string()
        .max(500, "Müşteri Entegrasyon Filtresi en fazla 500 karakter olabilir."),
    customerBalanceSql: string()
        .max(500, "Cari Bakiye Sorgusu en fazla 500 karakter olabilir."),
    erpServiceUrl: string()
        .max(200, "Servis URL en fazla 200 karakter olabilir."),
    projectCode: string()
        .max(20, "Proje Kodu en fazla 20 karakter olabilir."),
    salesmanCode: string()
        .max(20, "Satış Temsilcisi Kodu en fazla 20 karakter olabilir"),
    netsisParams: object({
        erpFirm: string()
            .max(50, "Firma Adı en fazla 50 karakter olabilir."),
        erpFirmCode: string()
            .max(50, "İşletme Kodu en fazla 50 karakter olabilir."),
        erpBranchCode: string()
            .max(20, "Şube Kodu en fazla 20 karakter olabilir."),
        erpUserName: string()
            .max(20, "ERP Kullanıcı Adı en fazla 20 karakter olabilir."),
        erpPassword: string()
            .max(20, "ERP Kullanıcı Şifresi en fazla 20 karakter olabilir."),
        dbType: string()
            .max(10, "Veri Tabanı Tipi en fazla 10 karakter olabilir."),
        dbUserName: string()
            .max(20, "Veri Tabanı Kullanıcı Adı en fazla 20 karakter olabilir."),
        dbPassword: string()
            .max(20, "Veri Tabanı Kullanıcı Şifresi en fazla 20 karakter olabilir."),
        referenceCode: string()
            .max(20, "Referans Kodu en fazla 20 karakter olabilir."),
        receiptSerialNo: string()
            .max(20, "Dekont Seri No en fazla 20 karakter olabilir."),
        customerProjectCodeColumn: string()
            .when("isCustomerProjectCode",{
                is: true,
                then: string()
                .required("Müşteri Kartı Proje Kodu Veritabanı Alanı zorunludur.")
                .max(50, "Müşteri Kartı Proje Kodu Veritabanı Alanı en fazla 50 karakter olabilir.")
            }),
        erpExchangeTypeNo: string()
            .when("isexchangeon", {
                is: true,
                then: string()
                .required("ERP Döviz Çevrim Tipi zorulu.")
            }),
        erpExchangeType: string()
            .when("isexchangeon", {
                is: true,
                then: string()
                .required("ERP Çevrim Kur Tipi seçimi zorunlu.")
            }),
        erpExchangeSymbol: string()
            .when("isexchangeon", {
                is: true,
                then: string()
                .required("Döviz Tipi Sembolü seçimi zorunlu.")
            })
    }),
    logoParams: object({
        divisionCode: string()
            .max(20, "İş Yeri Kodu en fazla 20 karakter olabilir."),
        departmentCode: string()
            .max(20, "Bölüm Kodu en fazla 20 karakter olabilir."),
        authCode: string()
            .max(20, "Yetki Kodu en fazla 20 karakter olabilir"),
        erpAuxcilCode: string()
            .max(50, "Özel Kod en fazla 50 karakter olabilir."),
        synctypeid: string()
            .required("ERP Fiş Tipi zorunludur."),
        erpFirmCode: string()
            .max(50, "Firma Kodu en fazla 50 karakter olabilir."),
        erpUserName: string()
            .max(20, "ERP Kullanıcı Adı en fazla 20 karakter olabilir."),
        erpPassword: string()
            .max(20, "ERP Kullanıcı Şifresi en fazla 20 karakter olabilir."),
    }),
})